<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/VKzHfC/image/cover.jpg?1731429802665" alt="This image is the cover for the book Signs, Symbols & Omens"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Signs, Symbols & Omens
      </h1>
      <p class="bookDescription body article font2">
        <p>As human beings, we live in a world of symbols. From traffic signs to the very letters that comprise these words, symbols are woven into every aspect of daily life. Since prehistoric times humans have used symbolic representation to communicate with each other and with the divine.</p><p>In <i>Signs, Symbols &amp; Omens</i>, leading occult authority Ray Buckland describes the form and meaning of over 800 symbols from ancient and modern religions, magical traditions, and indigenous cultures around the world:</p>AlchemyAncient EgyptAstrologyAustralian AboriginesAztec and MayanBuddhistCelticCeremonial MagicChineseChristianFreemasonryGnosticGreek and RomanHinduIslamicJudaicMagical AlphabetsNative AmericanNorseRosicrucianRunicShintoSikhTravelersVoudounWitchcraftOmens<p>Understand the symbols used throughout human history and gain a deeper appreciation for the depth of the human experience and the vast uncharted realm of the collective unconscious.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Raymond Buckland
      </h2>
      
      <p class="authorDescription body article"><P>Raymond Buckland was actively involved in metaphysics and the occult for fifty years. <BR /><BR />He was the author of more than sixty books, including such best-selling titles as <I>Buckland's Complete Book of Witchcraft</I>, <I>Gypsy Dream Dictionary</I>, <I>Practical Candleburning Rituals</I>, and <I>Witchcraft from the Inside</I>. Ray lectured and presented workshops across the United States, and appeared on major television and radio shows nationally and internationally. He also wrote screen plays, was a technical advisor for films, and appeared in films and videos. <BR /><BR />Ray came from an English Romany (Gypsy) family and resided with his wife Tara on a small farm in central Ohio. Beyond writing, Ray's other passion was homebuilt airplanes. </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Llewellyn Publications is an imprint of Llewellyn Worldwide Ltd. 
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?77145573